import { globalSettingsLayout } from '@atlassian/jira-global-settings-layout/src/index.tsx';
import { MENU_ID, SIDEBAR_ID } from '@atlassian/jira-navigation-apps-common/src/constants.tsx';
import AsyncSidebarGlobalSettingsProducts from '@atlassian/jira-navigation-apps-sidebar-global-settings-products/src/async.tsx';
import { createEntry } from '@atlassian/jira-route-entry/src/createEntry.tsx';
import {
	getNavigationResources,
	getNavigationSidebarProductsSettingResource,
} from '@atlassian/jira-router-resources-navigation/src/index.tsx';
import { polarisSettingsDatesRoute } from '@atlassian/jira-router-routes-polaris-routes/src/polarisSettingsDatesRoute.tsx';
import { polarisProductFinancialYearSettingsPageEntryPoint } from './ui/settings/financial-year/index.tsx';

export const polarisSettingsDatesRouteEntry = createEntry(polarisSettingsDatesRoute, () => ({
	isStrictModeEnabled: false,
	group: 'global-settings',
	layout: globalSettingsLayout,

	navigation: {
		sidebarId: SIDEBAR_ID.GLOBAL_PRODUCTS_SETTINGS,
		menuId: MENU_ID.SETTINGS,
		sidebar: AsyncSidebarGlobalSettingsProducts,
	},

	resources: [...getNavigationResources(), ...getNavigationSidebarProductsSettingResource()],

	entryPoint() {
		return polarisProductFinancialYearSettingsPageEntryPoint;
	},

	bifrost: {
		bifrostGroup: 'shell-only',

		bundling: {
			packageName:
				'@atlassian/jira-router-routes-polaris-entries/src/polarisSettingsDatesRouteEntry.tsx',
			whichExportToUse: 'polarisSettingsDatesRouteEntry',
		},

		enabled: true,
	},
}));
